module.exports = {
	//请求数据
	OrderAction_Init_Event: "OrderAction_Init_Event",
	//任务领取
	OrderAction_TaskGet_Event: "OrderAction_TaskGet_Event",
	//等级展示
	OrderAction_LevReward_Event: "OrderAction_LevReward_Event",
	//等级经验变化
	OrderAction_Updata_LevExp_Event: "OrderAction_Updata_LevExp_Event",
	//购买礼包卡
	OrderAction_BuyGiftCard_Event: "OrderAction_BuyGiftCard_Event",
	//是否活动结束弹窗
	OrderAction_IsPopWarn_Event: "OrderAction_IsPopWarn_Event",
}